import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import styles from './no-connection.module.scss';
import { getAuth0RedirectUri } from '@/utils/get-auth0-redirect-uri';

export const NoConnection = () => {
  const { logout } = useAuth0();
  const redirectUri = getAuth0RedirectUri();

  useEffect(() => {
    const checkConnection = async () => {
      if (!navigator.onLine) {
        return;
      }
      try {
        await fetch('https://www.google.com', { mode: 'no-cors' });
        // If request succeeds, the connection is stable - log out and redirect
        logout({
          logoutParams: {
            returnTo: redirectUri,
          },
        });
      } catch {
        // If request fails, connection is not stable yet, do nothing
      }
    };

    const handleOnlineStatus = () => {
      const intervalId = setInterval(async () => {
        await checkConnection();
      }, 2000); // Retry every 2 seconds until successful

      return () => clearInterval(intervalId);
    };

    window.addEventListener('online', handleOnlineStatus);

    return () => {
      window.removeEventListener('online', handleOnlineStatus);
    };
  }, [logout]);

  return (
    <div className={styles.noConnection}>
      <h1>You are offline</h1>
      <p>Login is only available with an Internet connection.</p>
    </div>
  );
};
